import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  useTable,
  useSortBy,
  usePagination,
  useGlobalFilter,
} from "react-table";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Table,
  Form,
  Modal,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
  TabPane,
  TabContent,
  NavItem,
  NavLink,
  Nav,
} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import Pagi2 from "common/utils/Pagi2";
import { CommonTableContainer } from "common/utils/ComonTableContainer";
import "../../common/styles/project.css";
import Swal from "sweetalert2";
import DemoPdf from "../../assets/PDF/blank.pdf";
import configure from "configure";
import classnames from "classnames";
import ViewProjectDetails from "./ViewProjectDetails";
import ViewMileStone from "./ViewMileStone";
import ViewTasks from "./ViewTasks";
import ViewNotes from "./ViewNotes";
import ViewActivityLogs from "./ViewActivityLogs";
import axios from "axios";
import moment from "moment";
import Loader from "components/Common/Loader";
import secureLocalStorage from "react-secure-storage";
import Pagination from "common/utils/Pagination";
import { customGlobalFilter } from "utils/common-helpers";

const projectStatus = [
  { label: "Not Started", value: "0" },
  { label: "In Progress", value: "1" },
  { label: "On Hold", value: "2" },
  { label: "Cancelled", value: "3" },
  { label: "Finished", value: "4" },
];
const ProjectIndex = () => {
  const [fixedContent, setFixedContent] = useState(false);

  const [modal_fullscreen, setmodal_fullscreen] = useState(false);
  const [verticalActiveTab, setverticalActiveTab] = useState("1");
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [ProjectData, setProjectData] = useState({});
  const [ProjectMilestone, setProjectMilestone] = useState([]);
  const [ProjectTask, setProjectTask] = useState([]);
  const [ProjectNote, setProjectNote] = useState([]);
  // const []

  useEffect(() => {
    fetchProject();
  }, []);

  const fetchProject = async () => {
    setLoading(true);
    const authUser = secureLocalStorage.getItem("Token");
    try {
      const res = await axios({
        method: "get",
        url: `${configure.apiUrl}/projects`,
        // data: formData,
        headers: {
          Authorization: `Bearer ${authUser}`,
        }
      }).then((res) => {
        setData(res.data.projects);
        // console.log("Fetch Project Data", res.data.data.project2)
        setLoading(false);
      });
    } catch (error) {
      console.log("Fetch Project Error", error);
      setLoading(false);
    }
  };

  document.title = "Project | Zithas Technologies";

  const navigate = useNavigate();

  document.addEventListener("scroll", () => {
    if (window.scrollY > 165) {
      setFixedContent(true);
    } else {
      setFixedContent(false);
    }
  });

  const toggleVertical = (tab) => {
    if (verticalActiveTab !== tab) {
      setverticalActiveTab(tab);
    }
  };

  const [fixedSideTab, setFixedSideTab] = useState(false);

  document.addEventListener("scroll", () => {
    if (window.scrollY > 68) {
      setFixedSideTab(true);
    } else {
      setFixedSideTab(false);
    }
  });

  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
        isInfoIcon: false,
        isShortIcon: true,
        className: "project_id",
        Cell: (cellProps) => {
          return <div className="text-centers">{cellProps.row.original.id}</div>;
        },
      },
      {
        Header: "Assignee",
        accessor: "kam_alias_name",
        isInfoIcon: false,
        isShortIcon: true,
        className: "project_id",
        Cell: (cellProps) => {
          return (
            <div className="text-centers d-flex align-items-center me-3">
              <img src={`${configure.imgUrl}/${cellProps.row.original.kam_avatar}`} alt="" className="img-fluid assignee-img me-3" title={cellProps.row.original.kam_alias_name} />
              {cellProps.row.original.kam_alias_name}
            </div>
          )
        },
      },

      {
        Header: "Project Name",
        accessor: "project_name",
        isInfoIcon: false,
        isShortIcon: true,
        className: "project_name",
        Cell: (cellProps) => {
          return (
            <div className="text-start text-capitalize">

              {cellProps.row.original.project_name || "-"}
            </div>
          );
        },
      },

      {
        Header: "Customer",
        accessor: "company",
        isInfoIcon: false,
        isShortIcon: true,
        className: "project_customer",
        Cell: (cellProps) => {
          const rowIndex = cellProps.row.index;
          return (
            <div className="text-start">
              {cellProps.row.original.customerDetails?.company || "-"}
            </div>
          );
        },
      },

      {
        Header: "Start Date",
        accessor: "startdate",
        isInfoIcon: false,
        isShortIcon: true,
        className: "project_start_date",
        Cell: (cellProps) => {
          return (
            <div className="text-center">
              {cellProps.row.original.startdate != null
                ? moment(cellProps.row.original.startdate.slice(0, 10)).format(
                  "DD-MM-YYYY"
                )
                : "-"}
            </div>
          );
        },
      },

      {
        Header: "Status",
        accessor: "status ",
        isInfoIcon: false,
        isShortIcon: true,
        className: "project_status",
        Cell: (cellProps) => {
          const Status = projectStatus?.filter(
            (item) => item.value === cellProps.row.original.status
          );
          return <div className="text-centers">{Status[0].label || "--"}</div>;
        },
      },

      {
        Header: "Action",
        accessor: "action",
        className: "project_action",
        isInfoIcon: false,
        Cell: (cellProps) => {
          const viewData = async (id) => {
            setmodal_fullscreen(true);
            setLoading(true);
            const token = secureLocalStorage.getItem("Token");
            try {
              const res = await axios
                .get(
                  `${configure.apiUrl}/projects/${id}`,
                  {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  }
                )
                .then((res) => {
                  setProjectData(res?.data?.project);
                  setProjectMilestone(res?.data?.milestones);
                  setProjectTask(res?.data?.tasks);
                  setProjectNote(res?.data?.notes);
                  setLoading(false);
                });
            } catch (error) {
              console.log("Customer - Profile", error);
              setLoading(false);
            }
          };
          return (
            <>
              <div className="d-flex justify-content-center">
                {/* <Link
                          to= "/edit_proposal"
                          className="btn btn-sm btn-outline-secondary me-1"
                          title="Edit Proposal"
                      >
                          <i className="fas fa-pen "></i>
                      </Link> */}
                <a
                  onClick={() => viewData(cellProps.row.original.id)}
                  className="btn btn-sm btn-outline-secondary me-1"
                  title="View Project"
                >
                  <i className="fas fa-eye "></i>
                </a>
              </div>
            </>
          );
        },
      },
    ],
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
      globalFilter: customGlobalFilter,
      initialState: {
        pageIndex: 0,
        sortBy: [{ id: "id", desc: true }],
      },
    },
    useGlobalFilter,
    usePagination
  )


  const { pageIndex, pageSize, globalFilter } = state;
  useEffect(() => setPageSize(50), []);

  return (
    <React.Fragment>
      {loading && <Loader />}
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title={"Dashboard"} breadcrumbItem={"Project"} />
          <Row>
            <Col lg={12} className="p-0">
              <Card>
                <CardBody>
                  <div className="responsive-table">
                    <div>
                      {/* fixed buttons */}
                      <div
                        className={`flex-column fixed-buttons pt-2 ${fixedContent ? "d-flex" : "d-none"
                          }`}
                      >
                        {/* <Link
                         to="/add_proposal" 
                         className=" btn ms-md-2 btn-save btn-label">
                            <i className="fas fa-plus me-1 label-icon"></i> Proposal
                        </Link>     */}
                        <button
                          onClick={() => navigate(-1)}
                          className="btn btn-red  fix-btn btn-label"
                        >
                          <i className="dripicons-cross me-2 icon-center label-icon"></i>
                          <span>Cancel</span>
                        </button>
                      </div>
                      <Row className="mb-2">
                        <Col className="col-2">
                          <select
                            className=" me-4 form-select"
                            style={{ width: "100px" }}
                            value={pageSize}
                            onChange={(e) => setPageSize(e.target.value)}
                          >
                            {[10, 25, 50, 100].map((pageSize) => (
                              <option key={pageSize} value={pageSize}>
                                Show {pageSize}
                              </option>
                            ))}
                          </select>
                        </Col>
                        <Col className="col-10 d-flex justify-content-end">
                          <div className="me-3">
                            <div className="search-box me-xxl-2 my-xxl-0 d-inline-block">
                              <div className="position-relative">
                                <label
                                  htmlFor="search-bar-0"
                                  className="search-label"
                                >
                                  <span
                                    id="search-bar-0-label"
                                    className="sr-only"
                                  >
                                    Search this table
                                  </span>
                                  <input
                                    onChange={(e) =>
                                      setGlobalFilter(e.target.value)
                                    }
                                    id="search-bar-0"
                                    type="text"
                                    className=" form-control rounded h-100"
                                    placeholder={`Search...`}
                                    value={globalFilter || ""}
                                  />
                                </label>
                                <i className="bx bx-search-alt search-icon"></i>
                              </div>
                            </div>
                          </div>

                          <div className="text-md-end">
                            {/* <Link
                             to="/add_proposal" 
                             className=" btn ms-md-2 btn-save  btn-label me-2">
                                <i className="fas fa-plus me-1 label-icon"></i> Proposal
                            </Link>  */}
                            <button
                              onClick={() => navigate(-1)}
                              className=" btn btn-red btn-label"
                            >
                              <i className="dripicons-cross me-2  lab label-icon"></i>
                              CANCEL
                            </button>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <div className="col-12">
                          <div className="position-relative shadow">
                            <table
                              className="table table-bordered mt-4"
                              {...getTableProps()}
                            >
                              <thead
                                className={`${fixedContent ? "fix-header" : ""
                                  } fix-lead-header`}
                              >
                                {headerGroups.map((headerGroup, i) => (
                                  <tr
                                    key={i}
                                    {...headerGroup.getHeaderGroupProps()}
                                  >
                                    {headerGroup.headers.map((column, index) => (
                                      <th
                                        key={index}
                                        className={`t-col-${index + 1} ${column.className
                                          }`}
                                        {...column.getHeaderProps()}
                                      >
                                        {column.render("Header")}
                                      </th>
                                    ))}
                                  </tr>
                                ))}
                              </thead>

                              <tbody
                                className="fix-lead-header"
                                {...getTableBodyProps()}
                              >
                                {page.map((row, i) => {
                                  prepareRow(row)
                                  let backColor
                                  if (row.original.lead_type == "Hot") {
                                    backColor = "bd-hot"
                                  }
                                  return (
                                    <tr
                                      className={`row-hover ${backColor}`}
                                      {...row.getRowProps()}
                                      key={i}
                                    >
                                      {row.cells.map((cell, index) => {
                                        return (
                                          <td
                                            key={index}

                                            className={`t-col-${index + 1} ${cell.column.className
                                              }`}
                                            {...cell.getCellProps()}
                                          >
                                            {cell.render("Cell")}
                                          </td>
                                        )
                                      })}
                                    </tr>
                                  )
                                })}
                                {page.length == 0 ? (
                                  <tr>
                                    <td className="text-center" colSpan={10}>
                                      No Leads Available
                                    </td>
                                  </tr>
                                ) : null}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </Row>

                      {/* Pagination */}
                      <Row className="justify-content-md-end justify-content-center align-items-center">
                        <Pagination
                          gotoPage={gotoPage}
                          previousPage={previousPage}
                          canPreviousPage={canPreviousPage}
                          nextPage={nextPage}
                          canNextPage={canNextPage}
                          pageIndex={pageIndex}
                          pageOptions={pageOptions}
                        />
                      </Row>

                      <Modal
                        size="xl"
                        isOpen={modal_fullscreen}
                        className="modal-fullscreen"
                      >
                        <div className="modal-header mb-0">
                          <div
                            className="d-flex align-items-center justify-content-between"
                            style={{ width: "100%" }}
                          >
                            <h5 className="col-6 modal-title mt-0">
                              Project Details
                            </h5>
                          </div>

                          <button
                            type="button"
                            onClick={() => {
                              setmodal_fullscreen(false);
                            }}
                            className="ms-4"
                            style={{
                              border: "none",
                              backgroundColor: "transparent",
                            }}
                          >
                            <span
                              aria-hidden="true"
                              style={{
                                color: "#bf1e30",
                                fontSize: "28px",
                                lineHeight: "1px",
                              }}
                            >
                              {" "}
                              &times;{" "}
                            </span>
                          </button>
                        </div>

                        <div className="modal-body hide-bottom-scrollbar  pe-0 pt-0 ">
                          <Row className="gx-4 justify-content-between ">
                            <Col md="2" className="px-0">
                              <Nav
                                pills
                                className={`side-tab flex-column px-2 py-3 bg-white  ${fixedSideTab ? "fixed-side-tab" : ""
                                  } h-100`}
                              >
                                <NavItem>
                                  <NavLink
                                    style={{ cursor: "pointer" }}
                                    className={classnames({
                                      "mb-2": true,
                                      active: verticalActiveTab === "1",
                                    })}
                                    onClick={() => {
                                      toggleVertical("1");
                                    }}
                                  >
                                    Project Details
                                  </NavLink>
                                </NavItem>

                                <NavItem>
                                  <NavLink
                                    style={{ cursor: "pointer" }}
                                    className={classnames({
                                      "mb-2": true,
                                      active: verticalActiveTab === "2",
                                    })}
                                    onClick={() => {
                                      toggleVertical("2");
                                    }}
                                  >
                                    Milestone
                                  </NavLink>
                                </NavItem>
                                <NavItem>
                                  <NavLink
                                    style={{ cursor: "pointer" }}
                                    className={classnames({
                                      "mb-2": true,
                                      active: verticalActiveTab === "3",
                                    })}
                                    onClick={() => {
                                      toggleVertical("3");
                                    }}
                                  >
                                    Task
                                  </NavLink>
                                </NavItem>
                                <NavItem>
                                  <NavLink
                                    style={{ cursor: "pointer" }}
                                    className={classnames({
                                      "mb-2": true,
                                      active: verticalActiveTab === "4",
                                    })}
                                    onClick={() => {
                                      toggleVertical("4");
                                    }}
                                  >
                                    Notes
                                  </NavLink>
                                </NavItem>
                                {/* <NavItem>
                                  <NavLink
                                    style={{ cursor: "pointer" }}
                                    className={classnames({
                                      "mb-2": true,
                                      active: verticalActiveTab === "5",
                                    })}
                                    onClick={() => {
                                      toggleVertical("5");
                                    }}
                                  >
                                    Activity Logs
                                  </NavLink>
                                </NavItem> */}
                              </Nav>
                            </Col>

                            <Col md="10" className="bd-right-side-tab">
                              <div className="px-4 h-100 pl-0 overflow-auto">
                                <TabContent
                                  activeTab={verticalActiveTab}
                                  className="text-muted mt-4 mt-md-0"
                                >
                                  <TabPane tabId="1">
                                    <ViewProjectDetails data={ProjectData} />
                                  </TabPane>
                                  <TabPane tabId="2">
                                    <ViewMileStone data={ProjectMilestone} />
                                  </TabPane>
                                  <TabPane tabId="3">
                                    <ViewTasks data={ProjectTask} />
                                  </TabPane>
                                  <TabPane tabId="4">
                                    <ViewNotes data={ProjectNote} />
                                  </TabPane>
                                  {/* <TabPane tabId="5">
                                    <ViewActivityLogs /> 
                                  </TabPane>*/}
                                </TabContent>
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </Modal>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ProjectIndex;
